import LTR from "@brand-icons/global/social-youtube/social-youtube-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialYoutubeIcon = iconFactory("SocialYoutubeIcon", LTR);
